import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'Загрузить таблицу',
      title: 'Загрузить таблицу',
      executeAction: 'Отправить',
      errorMessage: 'Ошибка',
      successMessage: 'Все %{count} строки добавлены',
      addedItemsCount: 'Добавлено строк',
      errorItems: 'Ошибки',
      fields: {
      },
    }
  }
}